import { Injectable, inject } from '@angular/core';

import { FsApi } from '@firestitch/api';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { isArray } from 'lodash-es';

@Injectable()
export class Data {
  protected _api = inject(FsApi);


  public get(url, data = {}, config: any = {}, key: string = null): Observable<any> {
    return this.request('get', url, data, config, key);
  }

  public put(url, data = {}, config: any = {}, key: string = null): Observable<any> {
    return this.request('put', url, data, config, key);
  }

  public post(url, data = {}, config: any = {}, key: string = null): Observable<any> {
    return this.request('post', url, data, config, key);
  }

  public delete(url, data = {}, config: any = {}, key: string = null): Observable<any> {
    return this.request('delete', url, data, config, key);
  }

  public request(method, url, data = {}, config: any = {}, key: string = null): Observable<any> {

    return this._api.request(method, url, data)
      .pipe(
        map((response: any) => {
          if (response && config.map !== false) {
            if (key) {
              const data = response[key];
              response[key] = isArray(data) ? data.map(this.map) : this.map(data);
            }

            if (config.key === undefined) {
              return response[key];
            }
          }

          return response;
        }),
      );
  }

  public map(data: any): any {
    return data;
  }

  public save(data, dummy = null): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

}
